// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CloseCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleTwoToneSvg
  }));
};

CloseCircleTwoTone.displayName = 'CloseCircleTwoTone';
export default React.forwardRef(CloseCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CloseCircleTwoTone.js
// module id = 787
// module chunks = 0